import React, { useState } from "react";
import SignIn from "./SignIn/SignIn";
import SignUp from "./SignUp/SignUp";

const Admin = () => {
  const [toggleForm, setToggleFrom] = useState("signin");

  const toggleFormHandler = () => {
    setToggleFrom("signup");
  };
  return (
    <div>
      {toggleForm === "signin" ? (
        <SignIn toggleForm={toggleFormHandler} />
      ) : (
        <SignUp />
      )}
    </div>
  );
};

export default Admin;
